/*eslint-disable */
var $ = window.jQuery = require('jquery');

import Router from 'vue-router'
import Vue from 'vue'
import store from './store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  canReuse: false,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [{
      path: '*',
      redirect: {
        name: 'HomeLandingMain'
      },
    },
    {
      path: '/',
      name: 'HomeLandingMain',
      component: () => import( /* webpackChunkName: "HomeLandingMain" */ './view/public/landing/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap';
        next();
      }
    },
    {
      path: '/login/',
      name: 'loginMainPage',
      component: () => import( /* webpackChunkName: "loginMainPage" */ './view/authentication/login-main-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Login';
        next();
      }
    },
    {
      path: '/request-password-reset/',
      name: 'requestPasswordReset',
      component: () => import( /* webpackChunkName: "requestPasswordReset" */ './view/authentication/forgot-password-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Request Password Reset';
        next();
      }
    },
    {
      path: '/signup/',
      name: 'signupPage',
      component: () => import( /* webpackChunkName: "signupPage" */ './view/authentication/singup-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Signup';
        next();
      }
    },
    {
      path: '/dashboard/',
      component: () => import( /* webpackChunkName: "Dashboard" */ './view/private/dashboard/index.vue'),
      beforeEnter: (to, from, next) => {
        store.dispatch('getAcUserDetailsFun');
        next();
      },
      children: [
        {
          path: '/',
          redirect: {
            name: 'DashboardMain'
          }
        },
        {
          path: '/home/',
          name: 'DashboardMain',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/private/home-dashboard/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getPublicBlogListAction');
            store.dispatch('getBlogListAction');
            store.dispatch('getAboutDetailsOfProfileFun');
            document.title = 'Lymphomap - Home';
            next();
          }
        },
        {
          path: '/profile/update/',
          name: 'profileUpdate',
          component: () => import( /* webpackChunkName: "profileUpdate" */ './view/private/profile-update/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Profile Update';
            next();
          }
        },
        {
          path: '/workspace/',
          name: 'teamWorkspace',
          component: () => import( /* webpackChunkName: "teamWorkspace" */ './view/private/workspace/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllLeftChatListDetailsFun');
            store.dispatch('getSchedulerListAction');
            document.title = 'Lymphomap - workspace';
            next();
          }
        },
        {
          path: '/chat/user/block/list/',
          name: 'userBlockList',
          component: () => import( /* webpackChunkName: "userBlockList" */ './view/private/blocked-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlockUserFun');
            document.title = 'Lymphomap - Member Block List';
            next();
          }
        },
        {
          path: '/members/',
          name: 'membersAllUsers',
          component: () => import( /* webpackChunkName: "membersAllUsers" */ './view/private/member-all-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberFilterCountFun');
            store.dispatch('memberAllUsersListFun');
            document.title = 'Lymphomap - Members';
            next();
          }
        },
        {
          path: '/members/connected/users/',
          name: 'membersConnectedUsers',
          component: () => import( /* webpackChunkName: "membersConnectedUsers" */ './view/private/member-connected-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('memberConnectedUsersListFun');
            store.dispatch('getConnectedMemberCountFun');
            document.title = 'Lymphomap - Members';
            next();
          }
        },
        {
          path: '/meeting/',
          name: 'meetingList',
          component: () => import( /* webpackChunkName: "meetingList" */ './view/private/create-meeting-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getMeetingAllListFun');
            document.title = 'Lymphomap - Meeting';
            next();
          }
        },
        {
          path: '/meeting/deleted/list/',
          name: 'deletedMeetingList',
          component: () => import( /* webpackChunkName: "deletedMeetingList" */ './view/private/deleted-meetings-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Deleted Meeting';
            next();
          }
        },
        {
          path: '/video/user/left/room/',
          name: 'UserLeftRoom',
          component: () => import( /* webpackChunkName: "UserLeftRoom" */ './view/private/user-left-room/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video Member Left Room';
            next();
          }
        },
        {
          path: '/members/users/details/:userDetailsId/',
          name: 'memberUserDetails',
          component: () => import( /* webpackChunkName: "memberUserDetails" */ './view/private/user-details/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getAboutDetailsOfMemberUserFun', {id:to.params.userDetailsId});
            document.title = 'Lymphomap - Member Details';
            next();
          }
        },
        {
          path: '/request/list/',
          name: 'saChatRequestList',
          component: () => import( /* webpackChunkName: "saChatRequestList" */ './view/private/chat-request-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('chatConnectionRequestListFun');
            document.title = 'Lymphomap - Member Request';
            next();
          }
        },
        {
          path: '/admin/user/guest/',
          name: 'guestUsersList',
          component: () => import( /* webpackChunkName: "guestUsersList" */ './view/private/guest-user-list/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getGuestUserListFun');
            document.title = 'Lymphomap - Guest Members';
            next();
          }
        },
        {
          path: '/vista/',
          name: 'vistaConference',
          component: () => import( /* webpackChunkName: "vistaConference" */ './view/private/vista-conference/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('vistaUnstyledMediaListFun');
            document.title = 'Lymphomap - Vista';
            next();
          }
        },
        {
          path: '/admin/filters/',
          name: 'memberFiltersCat',
          component: () => import( /* webpackChunkName: "memberFiltersCat" */ './view/private/members/members-filters-categories/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberMainFilterAction');
            document.title = 'Lymphomap - Filters';
            next();
          }
        },
        {
          path: '/admin/filters/:filterId/categories/',
          name: 'memberFiltersProCat',
          component: () => import( /* webpackChunkName: "memberFiltersCat" */ './view/private/members/members-professional-categories/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getMemberMainFilterDetailsByIdAction', {id:to.params.filterId});
            document.title = 'Lymphomap - Filter Categories';
            next();
          }
        },
        {
          path: '/video/call/one-to-one-peer/',
          name: 'videoCallOneToOnePeer',
          component: () => import( /* webpackChunkName: "videoCallOneToOnePeer" */ './view/private/jisti-video-confreness-for-one-to-one/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('checkRoomValidIdFun',{room_id:to.hash});
            store.dispatch('getAcUserDetailsFun').then((res)=>{
              next();
            });
            document.title = 'Lymphomap - Video Conference';
          }
        },
        {
          path: '/video/one-to-one-peer/left/room/',
          name: 'OneToOnePeerLeftRoom',
          component: () => import( /* webpackChunkName: "OneToOnePeerLeftRoom" */ './view/private/direct-call-from-user-left/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Video User Left Room';
            next();
          }
        },
        {
          path: '/conference/',
          name: 'videoConferenceMain',
          component: () => import( /* webpackChunkName: "videoConferenceMain" */ './view/private/jitsi-for-meetings-conf/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
           next();
          }
        },
        {
          path: '/conference/user/left/room/',
          name: 'UserLeftRoomInConference',
          component: () => import( /* webpackChunkName: "UserLeftRoomInConference" */ './view/private/conference-room-in-user-left/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Conference User Left Room';
            next();
          }
        },
        {
          path: '/webinar/',
          name: 'webinar',
          component: () => import( /* webpackChunkName: "webinar" */ './view/private/webinar-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getWebinarAllListFun')
            store.dispatch('getAllUserListsFun')
            document.title = 'Lymphomap - Webinar';
            next();
          }
        },
        {
          path: '/mobile/blog/',
          name: 'mobileViewBlog',
          component: () => import( /* webpackChunkName: "mobileViewBlog" */ './view/mobileView/blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getPublicBlogListAction');
            store.dispatch('getBlogListAction');
            document.title = 'Lymphomap - Blog';
            next();
          }
        },
        {
          path: '/blog/create/',
          name: 'blogCreate',
          component: () => import( /* webpackChunkName: "blogCreate" */ './view/private/blogs/create-blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Blog Create';
            next();
          }
        },
        {
          path: '/blog/update/:updateId/',
          name: 'blogUpdate',
          component: () => import( /* webpackChunkName: "blogUpdate" */ './view/private/blogs/update-blog/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlogDetailsByIdAction', {id:to.params.updateId});
            document.title = 'Lymphomap - Blog Update';
            next();
          }
        },  {
          path: '/blog/detail/:blogId',
          name: 'blogDetail',
          component: () => import( /* webpackChunkName: "blogDetail" */ './view/private/blogs/blog-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlogDetailsByIdAction', {id:to.params.blogId});
            store.dispatch('getBlogVoteInfoAction', {id:to.params.blogId});
            store.dispatch('getSuggestionBlogListAction');
            document.title = 'Lymphomap - Blog Detail';
            next();
          }
        },{
          path: '/private/blog/detail/:blogId',
          name: 'privateBlogDetail',
          component: () => import( /* webpackChunkName: "privateBlogDetail" */ './view/private/blogs/private-blog-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getBlogDetailsByIdAction', {id:to.params.blogId});
            store.dispatch('getBlogVoteInfoAction', {id:to.params.blogId});
            store.dispatch('getSuggestionBlogListAction');
            document.title = 'Lymphomap - Blog Detail';
            next();
          }
        },
        {
          path: '/data/',
          name: 'algoData',
          component: () => import( /* webpackChunkName: "algoData" */ './view/private/dataset/algo-dashboard/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Data';
            next();
          }
        },
        {
          path: '/data/old/',
          name: 'algoDataOLD',
          component: () => import( /* webpackChunkName: "algoDataOLD" */ './view/private/dataset/algo-data-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllPubAlgoDataListAction');
            store.dispatch('getAlgoDataListAction');
            document.title = 'Lymphomap - Data';
            next();
          }
        },
        {
          path: '/all/users/data/',
          name: 'algoAllUserData',
          component: () => import( /* webpackChunkName: "algoAllUserData" */ './view/private/dataset/algo-all-user-data/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getAllUserAlgoDataListAction');
            document.title = 'Lymphomap - Data';
            next();
          }
        },
        {
          path: '/ai/',
          name: 'AiDashboard',
          component: () => import( /* webpackChunkName: "AiDashboard" */ './view/private/ai-dashboard/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - AI Dashboard';
            next();
          }
        },
        {
          path: '/ai/models/create/',
          name: 'AiModelsCreated',
          component: () => import( /* webpackChunkName: "AiModelsCreated" */ './view/private/ai-dashboard/create-new-models/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getDiseaseListForAiDashFun');
            store.dispatch('getMostUsedTrainModelForAiDashFun');
            document.title = 'Lymphomap - AI Models Create';
            next();
          }
        },
        {
          path: '/ai/public/models/:pubModelsId',
          name: 'publicModelsMake',
          component: () => import( /* webpackChunkName: "publicModelsMake" */ './view/private/ai-dashboard/make-public-models/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getMostUsedTrainModelForAiDashFun');
            store.dispatch('getModelDetailsByIDForAIFun', {id:to.params.pubModelsId});
            document.title = 'Lymphomap - AI Public Models';
            next();
          }
        },
        {
          path: '/ai/models/use/:useModelsId',
          name: 'useModelsData',
          component: () => import( /* webpackChunkName: "useModelsData" */ './view/private/ai-dashboard/new-model-use/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getModelDetailsByIDForAIFun', {id:to.params.useModelsId});
            document.title = 'Lymphomap - AI Use Models';
            next();
          }
        },
          {
          path: '/awerack/',
          component: () => import( /* webpackChunkName: "Dashboard" */ './view/private/paperpiles/awerack-root/index.vue'),
          beforeEnter: (to, from, next) => {
            store.dispatch('getBucketListOfAwerackFun');
            next();
          },
          children: [
            {
              path: '/awerack/paper/list/',
              name: 'paperPiles',
              component: () => import( /* webpackChunkName: "paperPiles" */ './view/private/paperpiles/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun');
                document.title = 'Lymphomap - AweRack';
                next();
               }
            },
            {
              path: '/awerack/shared/paper/',
              name: 'awerackSharedPaper',
              component: () => import( /* webpackChunkName: "awerackSharedPaper" */ './view/private/paperpiles/shared-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getSharedPaperListFun');
                document.title = 'Lymphomap - AweRack Shared Paper';
                next();
               }
            },
            {
              path: '/awerack/paper/favourites/',
              name: 'favouritePaperList',
              component: () => import( /* webpackChunkName: "favouritePaperList" */ './view/private/paperpiles/favourite-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getFavouritePaperListFun');
                document.title = 'Lymphomap - Favourite Paper';
                next();
               }
            },
            {
              path: '/awerack/paper/trash/',
              name: 'trashPaperList',
              component: () => import( /* webpackChunkName: "trashPaperList" */ './view/private/paperpiles/trash-paper-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getTrashPaperListFun');
                store.dispatch('getTrashFolderListFun');
                document.title = 'Lymphomap - Trash Paper';
                next();
               }
            },
            {
              path: '/awerack/preference/',
              name: 'paperPilesPreferences',
              component: () => import( /* webpackChunkName: "paperPilesPreferences" */ './view/private/paperpiles/paper-preferences/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                document.title = 'Lymphomap - AweRack Preference';
                next();
              }
            }, 
            {
              path: '/awerack/research-group/',
              name: 'awerackResearchGroup',
              component: () => import( /* webpackChunkName: "awerackResearchGroup" */ './view/private/paperpiles/research-group-list/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getAllPaperPileFun');
                store.dispatch('getResearchGroupListFun');
                store.dispatch('getAllUserListsFun');
                document.title = 'Lymphomap - AweRack Research Group';
                next();
              }
            },
            {
              path: '/awerack/research-group/details/:researchGId',
              name: 'awerackResearchGroupDetails',
              component: () => import( /* webpackChunkName: "awerackResearchGroupDetails" */ './view/private/paperpiles/research-group-detail/index.vue'),
              guest: true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getResearchGroupDetailsByIDFun', {id:to.params.researchGId});
                document.title = 'Lymphomap - Research Group Details';
                next();
              }
            },
            {
              path: '/awerack/bucket/:bucketId',
              name: 'bucketDetails',
              component: () => import( /* webpackChunkName: "bucketDetails" */ './view/private/paperpiles/bucket-details/index.vue'),
              guest: true,
              props:true,
              beforeEnter: (to, from, next) => {
                store.dispatch('getBucketDetailsByIdOfAwerackFun', {id:to.params.bucketId});
                document.title = 'Lymphomap - AweRack Bucket';
                next();
              }
            },
            ]
        },
        {
          path: '/bot/tickets/',
          name: 'botTickets',
          component: () => import( /* webpackChunkName: "botTickets" */ './view/private/bot-tickets/index.vue'),
          guest: true,
          props:true,
          beforeEnter: (to, from, next) => {
            store.dispatch('botTicketListAction');
            document.title = 'Lymphomap - Bot Tickets';
            next();
          }
        },
        {
          path: '/core/user/',
          name: 'teamUserList',
          component: () => import( /* webpackChunkName: "teamUserList" */ './view/private/teams/team-users-list/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Core Member List';
            next();
          }
        },
        {
          path: '/core/user/update/:updateID',
          name: 'teamUserUpdate',
          component: () => import( /* webpackChunkName: "teamUserUpdate" */ './view/private/teams/update-user-info-for-team/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserInfoByIdForTeamHeadFun', {id:to.params.updateID});
            document.title = 'Lymphomap - Core Member Update';
            next();
          }
        },
        {
          path: '/core/user/add/',
          name: 'teamUserAdd',
          component: () => import( /* webpackChunkName: "teamUserAdd" */ './view/private/teams/create-user-info-for-team/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Core Member Add';
            next();
          }
        }, 
        {
          path: '/core/user/activity/:userID',
          name: 'teamUserActivity',
          component: () => import( /* webpackChunkName: "teamUserActivity" */ './view/private/teams/user-activity-for-team/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserInfoByIdForTeamHeadFun', {id:to.params.userID});
            store.dispatch('getUserActivityByIDOfTeamHeadFun', {id:to.params.userID});
            document.title = 'Lymphomap - Core Member Activity';
            next();
          }
        },
        {
          path: '/core/user/ai/:userID',
          name: 'teamUserAI',
          component: () => import( /* webpackChunkName: "teamUserAI" */ './view/private/teams/ai-info-of-member/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            store.dispatch('getUserInfoByIdForTeamHeadFun', {id:to.params.userID});
            store.dispatch('getModelListForTeamHeadFun', {id:to.params.userID});
            store.dispatch('getModelCountForTeamHeadFun', {id:to.params.userID});
            store.dispatch('getMostUsedTrainModelForTeamHeadFun', {id:to.params.userID});
            document.title = 'Lymphomap - Core Member AI';
            next();
          }
        },
        {
          path: '/coming-soon/',
          name: 'comingSoon',
          component: () => import( /* webpackChunkName: "comingSoon" */ './view/public/coming-soon/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Coming Soon';
            next();
          }
        },
        {
          path: '/under/maintenance/',
          name: 'underMaintenance',
          component: () => import( /* webpackChunkName: "underMaintenance" */ './view/public/under-maintenance-page/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Under Maintenance';
            next();
          }
        },
        {
          path: '/page/maintenance/',
          name: 'underPageMaintenance',
          component: () => import( /* webpackChunkName: "underPageMaintenance" */ './view/public/page-maintenance/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Under Maintenance';
            next();
          }
        },
        {
          path: '/education-coming-soon/',
          name: 'educationComingSoon',
          component: () => import( /* webpackChunkName: "educationComingSoon" */ './view/public/coming-soon/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Coming Soon';
            next();
          }
        },
        {
          path: '/vista-coming-soon/',
          name: 'vistaComingSoon',
          component: () => import( /* webpackChunkName: "vistaComingSoon" */ './view/public/coming-soon/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Coming Soon';
            next();
          }
        },
        {
          path: '/vista/detail/:videoID/',
          name: 'VistaMediaInfo',
          component: () => import( /* webpackChunkName: "VistaMediaInfo" */ './view/private/vista-media-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Media';
            next();
          }
        },
        {
          path: '/vista/private/media/details/:videoID/',
          name: 'VistaPrivateMediaInfo',
          component: () => import( /* webpackChunkName: "VistaPrivateMediaInfo" */ './view/private/vista-private-media-details/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Vista Private Media';
            next();
          }
        },
        {
          path: '/payment/history/',
          name: 'paymentHistory',
          component: () => import( /* webpackChunkName: "paymentHistory" */ './view/private/payment-history/index.vue'),
          guest: true,
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment History';
            next();
          }
        },
        {
          path: '/pay-online-consult/neural-package/',
          name: 'paymentCheckoutNeuralPackage',
          component: () => import( /* webpackChunkName: "paymentCheckoutNeuralPackage" */ './view/private/payment-checkout/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment For Neural Package';
            next();
          }
        },
        {
          path: '/pay-online-consult/neural-package/upgrade/',
          name: 'paymentCheckoutUpgradeNowNeuralPackage',
          component: () => import( /* webpackChunkName: "paymentCheckoutUpgradeNowNeuralPackage" */ './view/private/upgrade-now-payment-checkout/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment For Neural Package';
            next();
          }
        },
        {
          path: '/pay-online-consult/supervised-package/',
          name: 'paymentCheckoutSupervisedPackage',
          component: () => import( /* webpackChunkName: "paymentCheckoutsupervisedPackage" */ './view/private/payment-checkout-supervised-package/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment For Supervised Package';
            next();
          }
        },
        {
          path: '/free-trial-payment-checkout/neural-package/',
          name: 'freeTrialPaymentCheckout',
          component: () => import( /* webpackChunkName: "freeTrialPaymentCheckout" */ './view/private/free-trial-payment-checkout/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment For Neural Package';
            next();
          }
        },
        {
          path: '/payment/success/',
          name: 'paymentSuccess',
          component: () => import( /* webpackChunkName: "paymentSuccess" */ './view/private/payment-success/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment Success';
            next();
          }
        },
        {
          path: '/payment/failed/',
          name: 'paymentFailed',
          component: () => import( /* webpackChunkName: "paymentFailed" */ './view/private/payment-failed/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            document.title = 'Lymphomap - Payment Failed';
            next();
          }
        },
        {
          path: '/notifications/',
          name: 'globalNotification',
          component: () => import( /* webpackChunkName: "globalNotification" */ './view/private/notifications/index.vue'),
          props: (route) => ({
            to: route.query.to,
            stage: route.query.stage,
            bg: route.query.bg
          }),
          beforeEnter: (to, from, next) => {
            store.dispatch('getGlobalNotificationMethod', {flag:'False'});
            document.title = 'Lymphomap - Notifications';
            next();
          }
        },
      ]
    },
    {
      path: '/interviewer/:contestId',
      name: 'interviewerContest',
      component: () => import( /* webpackChunkName: "interviewerContest" */ './view/public/interviewer/contest-info-page/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Interviewer Contest';
        next();
      }
    },
    {
      path: '/all/event/list/',
      name: 'allEventList',
      component: () => import( /* webpackChunkName: "allEventList" */ './view/public/event/all-event-list/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Event Lists';
        next();
      }
    },
    {
      path: '/event/info/:evtId',
      name: 'eventInfo',
      component: () => import( /* webpackChunkName: "eventInfo" */ './view/public/event/event-info/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Event Info';
        next();
      }
    },
    {
      path: '/collaboration/info/',
      name: 'collaborationInfo',
      component: () => import( /* webpackChunkName: "collaborationInfo" */ './view/public/collaboration-project-info/index.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Project Collaboration Info';
        next();
      }
    },
    {
      path: '/tukivita/info/',
      name: 'tukivitaInfo',
      component: () => import( /* webpackChunkName: "tukivitaInfo" */ './view/public/tukivita/info.vue'),
      props: (route) => ({
        to: route.query.to,
        stage: route.query.stage,
        bg: route.query.bg
      }),
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Tukivita Info';
        next();
      }
    },
    {
      path: '/presentation_1.0/',
      name: 'presentation',
      component: () => import( /* webpackChunkName: "presentation" */ './view/public/presentation/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Presentation';
        next();
      }
    },
    {
      path: '/discoverus/presentation_2.0/',
      name: 'presentationUpgradeVersion',
      component: () => import( /* webpackChunkName: "presentationUpgradeVersion" */ './view/public/presentation-version-upgrade/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Lymphomap Discover Us';
        next();
      }
    },
    {
      path: '/31-october-conference/',
      name: 'octoberConference',
      component: () => import( /* webpackChunkName: "octoberConference" */ './view/public/lymphomap-conference/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('getPublicVistaMeetingFun');
        document.title = 'Lymphomap - Conference';
        next();
      }
    },
    {
      path: '/public/blog/detail/:pubBlogId',
      name: 'pubBlogDetail',
      component: () => import( /* webpackChunkName: "pubBlogDetail" */ './view/private/blogs/public-blog-details/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('getPublicBlogDetailsByIdAction', {id:to.params.pubBlogId});
        store.dispatch('getSuggestionBlogListAction');
        document.title = 'Lymphomap - Blog Detail';
        next();
      }
    },
    {
      path: '/member/agreement/',
      name: 'userAgreement',
      component: () => import( /* webpackChunkName: "userAgreement" */ './view/public/user-agreement/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Member Agreement';
        next();
      }
    },
    {
      path: '/privacy-policy/',
      name: 'privacyPolicy',
      component: () => import( /* webpackChunkName: "privacyPolicy" */ './view/public/privacy-policy/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Privacy Policy';
        next();
      }
    },
    {
      path: '/our/services/',
      name: 'ourServices',
      component: () => import( /* webpackChunkName: "ourServices" */ './view/public/services/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Our Services';
        next();
      }
    },
    {
      path: '/tracking/unsubscribe/:unsubscribeID',
      name: 'trackingUnsubscribe',
      component: () => import( /* webpackChunkName: "trackingUnsubscribe" */ './view/public/unsubscribe/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Unsubscribe';
        next();
      }
    },
    {
      path: '/contact-us/',
      name: 'contactUs',
      component: () => import( /* webpackChunkName: "contactUs" */ './view/public/contact-us/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Contact Us';
        next();
      }
    },
    {
      path: '/team/',
      name: 'ourTeam',
      component: () => import( /* webpackChunkName: "ourTeam" */ './view/public/our-team-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Team';
        next();
      }
    },
    {
      path: '/public/webinar/',
      name: 'publicWebinar',
      component: () => import( /* webpackChunkName: "publicWebinar" */ './view/public/public-webinar-conf/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Webinar';
        next();
      }
    },
    {
      path: '/public/webinar/left/room/',
      name: 'publicWebinarLeftRoom',
      component: () => import( /* webpackChunkName: "publicWebinarLeftRoom" */ './view/public/public-webinar-left-user-to-room/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Webinar Left Room';
        next();
      }
    },
    {
      path: '/interview/',
      name: 'userInterview',
      component: () => import( /* webpackChunkName: "userInterview" */ './view/public/interview-confernce-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Interview';
        next();
      }
    },
    {
      path: '/interview/left/room/',
      name: 'interviewLeftRoom',
      component: () => import( /* webpackChunkName: "interviewLeftRoom" */ './view/public/interview-left-confernce-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Interview Left Room';
        next();
      }
    },
    {
      path: '/public/meeting/',
      name: 'publicMeeting',
      component: () => import( /* webpackChunkName: "publicMeeting" */ './view/public/public-meeting-conf/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Meeting';
        next();
      }
    },
    {
      path: '/public/meeting/left/room/',
      name: 'publicMeetingLeftRoom',
      component: () => import( /* webpackChunkName: "publicMeetingLeftRoom" */ './view/public/public-meeting-left-user-to-room/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Meeting Left Room';
        next();
      }
    },
    {
      path: '/public/vista/',
      name: 'publicVistaMedia',
      component: () => import( /* webpackChunkName: "publicVistaMedia" */ './view/public/vista-public-media-list/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('vistaPublicMediaListFun');
        document.title = 'Lymphomap - Media';
        next();
      }
    },
    {
      path: '/public/vista/detail/:videoID/',
      name: 'publicVistaMediaInfo',
      component: () => import( /* webpackChunkName: "publicVistaMediaInfo" */ './view/public/vista-public-media-details/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('vistaPublicMediaListFun');
        document.title = 'Lymphomap - Media';
        next();
      }
    },
    {
      path: '/form/:userId/',
      name: 'feedbackForm',
      component: () => import( /* webpackChunkName: "feedbackForm" */ './view/public/feedback-form/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Form';
        next();
      }
    },
    {
      path: '/demo-request/feedback/:selfToken/',
      name: 'demoRequestFeedback',
      component: () => import( /* webpackChunkName: "demoRequestFeedback" */ './view/public/demo-request-feedback/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Demo Request Feedback';
        next();
      }
    },
    {
      path: '/webinar-promotion-jascap/',
      name: 'webinarPromotionJascap',
      component: () => import( /* webpackChunkName: "webinarPromotionJascap" */ './view/public/promotion/jascap-webinar-promotion-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Webinar Promotion Jascap';
        next();
      }
    },
    {
      path: '/launch/conference/info',
      name: 'launchConferenceInfo',
      component: () => import( /* webpackChunkName: "launchConferenceInfo" */ './view/public/lbil_launch_webinar/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Launch Conference Info';
        next();
      }
    },
    {
      path: '/packages/',
      name: 'membershipPackages',
      component: () => import( /* webpackChunkName: "membershipPackages" */ './view/public/membership-packages-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('getAllPlansListFunc');
        document.title = 'Lymphomap - Packages';
        next();
      }
    },
    {
      path: '/our/app/',
      name: 'ourApp',
      component: () => import( /* webpackChunkName: "ourApp" */ './view/public/our-app-page-info/index.vue'),
      guest: true,
      props:true,
      beforeEnter: (to, from, next) => {
        document.title = 'Lymphomap - Our App';
        next();
      }
    },
    {
      path: '/about-us/',
      name: 'AboutUsMainPage',
      component: () => import( /* webpackChunkName: "AboutUsMainPage" */ './view/public/about-us-main-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - About Us';
       next();
      }
    },
    {
      path: '/faq/',
      name: 'faqPage',
      component: () => import( /* webpackChunkName: "faqPage" */ './view/public/faq/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - faq';
       next();
      }
    },
    {
      path: '/cancer-classification/',
      name: 'cancerClassificationPage',
      component: () => import( /* webpackChunkName: "cancerClassificationPage" */ './view/public/mobile/cancer-classification-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - Cancer Classification Info';
       next();
      }
    },
    {
      path: '/ai-algoriths/',
      name: 'aiAlgorithmPage',
      component: () => import( /* webpackChunkName: "aiAlgorithmPage" */ './view/public/mobile/ai-algorithms-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - Ai Algorithms Info';
       next();
      }
    },
    {
      path: '/lbil/info/',
      name: 'LbilInfoPage',
      component: () => import( /* webpackChunkName: "LbilInfoPage" */ './view/public/mobile/LBIl-info-page/index.vue'),
      guest: true,
      beforeEnter: (to, from, next) => {
       document.title = 'Lymphomap - LBIL Info';
       next();
      }
    }
  ]
})

// Routes use for without login. these are the name of routes not path
// 'ourTeam'
const openRoutes = ['notFoundPage', 'octoberConference', 'HomeLandingMain', 'presentation', 'presentationUpgradeVersion', 'privacyPolicy', 'userAgreement', 'pubBlogDetail', 'trackingUnsubscribe', 'contactUs','publicWebinar', 'publicWebinarLeftRoom', 'publicVistaMedia', 'publicVistaMediaInfo', 'ourTeam', 'feedbackForm', 'demoRequestFeedback', 'publicMeeting', 'publicMeetingLeftRoom', 'launchConferenceInfo', 'membershipPackages', 'signupPage','loginMainPage','ourApp', 'AboutUsMainPage', 'requestPasswordReset', 'cancerClassificationPage', 'aiAlgorithmPage', 'LbilInfoPage', 'userInterview', 'interviewLeftRoom', 'webinarPromotionJascap', 'eventInfo', 'allEventList', 'interviewerContest', 'collaborationInfo', 'ourServices', 'faqPage']

// Routes use for without login
router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    next();
  } else if (store.getters.isAuthenticated && localStorage.getItem('token') != '' && localStorage.getItem('token') != null && localStorage.getItem('LoginedUserID') != '' && localStorage.getItem('LoginedUserID') != null) {
    next();
  } else {
    if(to.name != "blogDetail"){
      let redirectTo = to.path;
      let redirectToHash = to.hash;
      let redirectToFull = '?redirect=' + redirectTo + redirectToHash;
      if(window.innerWidth > 1023){
        next('/' + redirectToFull);
      }else{
        next('/login/' + redirectToFull);
      }
    }else{
      next('/public/blog/detail/'+to.params.blogId);
    }
  }
})

/** Show loader when moving routes */
router.beforeResolve((to, from, next) => {
	if (to.name) {
		if (openRoutes.includes(to.name)) {
			$(".preloader").show();
		}
		next();
	}
});

/** Hide preloader after each routes */
router.afterEach((to, from) => {
	if (openRoutes.includes(to.name)) {
		$(".preloader").delay(200).fadeOut("slow");
	}
});

export default router;